<template>
  <div class="fee">
     <div class="top">
          <img v-if="top_url" :src="top_url" />
      </div>
      <div class="KV">
          <img v-if="banner_url" :src="banner_url" />
      </div>
      <div class="fee">
          <van-form label-width="120px" input-align="right" error-message-align="right" ref="form">
            <van-cell-group inset style="margin:0;">
                <van-field
                v-model="form.realname"
                name="姓名"
                label="姓名"
                placeholder="请输入"
                required
                :disabled="disabled"
                :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                v-model="form.bank"
                name="银行"
                label="银行"
                placeholder="请输入"
                required
                :disabled="disabled"
                :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                v-model="form.opening_bank"
                name="开户行"
                label="开户行"
                placeholder="请输入"
                required
                :disabled="disabled"
                :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                v-model="form.bank_card"
                type="number"
                name="银行卡号"
                label="银行卡号"
                placeholder="请输入"
                required
                :disabled="disabled"
                :rules="[{ required: true, message: '请填写' }]"
                />
            </van-cell-group>
            <van-cell-group style="margin:20px 0;">
                <van-field
                v-model="form.id_card_num"
                name="身份证号"
                label="身份证号"
                placeholder="请输入"
                required
                :disabled="disabled"
                :rules="[
                    {required: true, message: '请填写' }]"
                />


            <div class="flex">
                <van-field name="uploader" input-align="center"
                v-model="form.id_card_front"
                :disabled="disabled"
                :rules="[{ required: true, message: '请上传身份证正面' }]"
                 error-message-align="center"
                >
                    <template #input>
                        <van-uploader v-model="frontList" :max-count="1"
                        :after-read="(file) => afterReadFront(file)"
                        :before-delete="(file) =>beforeDeleteFront(file)"
                        :disabled="disabled"
                        :deletable="disabled==false">
                        </van-uploader>
                        <p><span style="color:#ee0a24;">*</span>正面</p>
                    </template>
                </van-field>

                <van-field name="uploader" input-align="center"
                v-model="form.id_card_back"
                :disabled="disabled"
                :rules="[{ required: true, message: '请上传身份证反面' }]"
                 error-message-align="center"
                >
                    <template #input>
                        <van-uploader v-model="backList" :max-count="1"
                        :after-read="(file) => afterReadBack(file)"
                        :before-delete="(file) =>beforeDeleteBack(file)"
                        :disabled="disabled"
                        :deletable="disabled==false">
                        </van-uploader>
                        <p><span style="color:#ee0a24;">*</span>反面</p>
                    </template>
                </van-field>
            </div>
            </van-cell-group>
            <input type="checkbox" v-model="agree" :disabled="disabled"/>
            <span style="color:#c8c9cc">尊敬的专家，您好，感谢您填写您的劳务信息，勾选此项则表示您同意将您的学术演讲内容（视频）用于CEC官方APP上对外公开进行视频的录播回看，有效期为1年，谢谢您。</span>
            <div style="margin: 16px;">
                <van-button  block @click="upload"  v-if="disabled==false"
                style="background-color:#B01C06;color:white;border-radius:10px;"
                :disabled="buttonDisabled">
                {{uploadText}}
                </van-button>
                <van-button  block @click="changeText"  v-else
                style="background-color:#B01C06;color:white;border-radius:10px;"
                :disabled="buttonDisabled">
                {{uploadText}}
                </van-button>
            </div>
        </van-form>
          
      </div>
      <!-- <div class="back" @click="goIndex()">
            <img src="@/assets/images/collection/back_index.png" />
      </div> -->
  </div>
</template>

<script>
import {PersoanalUserInfo,UploadCertificates,Register} from '../../config/interface.js'
export default {
    data(){
        return{
            userInfo:{},
            form:{
                realname:'',
                bank:'',
                opening_bank:'',
                bank_card:'',
                id_card_num:'',
                id_card_front:'',
                id_card_back:''
            },
            frontList:[],
            backList:[],
            uploadText:'确认提交',
            disabled:false,
            buttonDisabled:false,
            id:this.$route.query.id,
            top_url:'',
            banner_url:'',
            agree:true
        }
    },
    created(){
        this.getUserInfo();
        this.getSetting();
        document.title="CEC官方";
        // if(common.is_weixin()){
		// 	common.wxShare('课题申报@中国血管论坛CEC2022','上报课题截止时间：2022年9月1日，欢迎您填写您的课题，谢谢您。','cdn.edstatic.com/203012120000/b20d0c68aad9dc88de3d7708dbf6c374/2022/07/9a6c31a0-d2f1-490c-8aa0-5942dc78e9dc.png');
		// }

    },
    methods:{
        //得到用户信息
        getUserInfo(){
            const url=PersoanalUserInfo;
            let params={};
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    localStorage.setItem('userInfo',JSON.stringify(data));
                    this.$store.dispatch('storageUserInfo',data);	
                    this.userInfo=data;
                    if(this.userInfo&&this.userInfo.mobile_status==1){
                        this.form={
                            realname:data.realname,
                            bank:data.bank,
                            opening_bank:data.opening_bank,
                            bank_card:data.bankcard,
                            id_card_num:data.id_card_num,
                            id_card_front:data.id_card_front,
                            id_card_back:data.id_card_back
                        }
                        if(data.id_card_front)
                            this.frontList = [{ url: data.id_card_front_preview, isImage: true }];
                        if(data.id_card_back)
                            this.backList = [{ url: data.id_card_back_preview, isImage: true }];
                        if(data.realname&&data.bank&&data.opening_bank&&data.bankcard&&data.id_card_num){
                            this.disabled=true;
                            this.uploadText='修改信息';
                        }
                    }
                    else{
                        common.toast('未绑定手机',1000,'fail',()=>{
                                this.$router.replace({
                                path:'/collection/login',
                                query:{url:window.location.href}
                        })
                        })	
                    }
                }
            })
        },
        changeText(){
            this.disabled=false;
            this.uploadText="提交修改";
        },
        upload(){
            this.$refs['form'].validate().then(()=>{
                this.onSubmit();
            }).catch(() => {
		        //失败时的程序
			})
        },
        onSubmit(){
            if(this.disabled==false)
            {
                if(this.agree==false){
                    common.toast("请勾选同意规则")
                    return
                }
                this.buttonDisabled=true;
                const url=Register;
                let params={
                    realname:this.form.realname,
                    bank:this.form.bank,
                    opening_bank:this.form.opening_bank,
                    bankcard:this.form.bank_card,
                    id_card_num:this.form.id_card_num,
                    id_card_front:this.form.id_card_front,
                    id_card_back:this.form.id_card_back
                };
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    this.buttonDisabled=false;
                    if(res.code==0){
                        this.uploadText='修改信息';
                        this.disabled=true;
                        common.toast('提交成功',1000,'success',()=>{
                        })	
                        
                    }
                })
            }
            else{
                this.disabled=false;
                this.uploadText="提交修改";
            }
        },
        goIndex(){
            this.$router.push({
				path:'/collection/index',
                query:{
                    id:this.id
                }
			});
        },
         afterReadFront(file){
            const url=UploadCertificates;  
            let formData=new FormData();
            formData.append('certificates[0][file]',file.file);
            formData.append('certificates[0][type]',1)
            const method='POST';
            fetch(url,formData,method)
            .then((res)=>{
                if(res.code==0){
                    this.form.id_card_front=res.data[0].path;
                }
            })
        },
        afterReadBack(file){
            const url=UploadCertificates;  
            let formData=new FormData();
            formData.append('certificates[0][file]',file.file);
            formData.append('certificates[0][type]',2)
            const method='POST';
            fetch(url,formData,method)
            .then((res)=>{
                if(res.code==0){
                    this.form.id_card_back=res.data[0].path;
                }
            })
        },
        beforeDeleteFront(file){
            this.form.id_card_front='';
            return  ()=>{}
        },
        beforeDeleteBack(file){
            this.form.id_card_back='';
            return  ()=>{}
        },
        getSetting(){
            const url='webapi/meetings/'+this.id+'/collects';
            //post必填参数，title,content，可选参数code
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.top_url=data.top_img;
                    this.banner_url=data.banner;
                }
            })
        },

    }

}
</script>

<style lang="scss">
.fee{
    margin-bottom: 30px;
    .top{
        img{
            width: 100%;
        }
    }
    .KV{
        margin: 15px 15px 0;
        img{
            width: 100%;
            border-radius: 10px;
        }
    }
    .fee{
        margin: 0 15px;
        border-radius: 5px;
        box-shadow: 0px 2px 4px #f2f2f2; 
        .van-cell{
            line-height: 1rem;
            font-size: 16px;
        }
        .van-field__control--custom{
            display: block !important;
        }
        .van-cell__right-icon{
            line-height: 1rem;
        }
        .van-uploader{
            width: 100%;
        }
        .van-uploader__upload{
            width: 80%;
            margin: 0 auto;
        }
        .van-uploader__preview{
            margin: 0 auto;
        }

    }
    .back{
        position: fixed;
        right: 0;
        bottom: 10%;
        img{
            height: 40px;
        }
    }
    
    
}
.van-field--disabled .van-field__label {
    color: #323233 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Contributions/fee.vue